import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../styles/Pages.css';
import { useEffect } from 'react';
import images from '../assets/index';

function AboutUs() {

  // Core Values Data
  const coreValues = [
    {
      title: "Client-Promise First",
      description: "We put our clients at the center of everything we do, delivering on promises with transparency and dedication.",
      image: images.clientlaptop
    },
    {
      title: "Innovation with Purpose",
      description: "We drive meaningful innovation that solves real business challenges and creates lasting value.",
      image: images.newcase3
    },
    {
      title: "Excellence & Ownership",
      description: "We take full ownership of our work and strive for the highest standards of quality in every deliverable.",
      image: images.tech
    },
    {
      title: "Global Stewardship",
      description: "We act responsibly across borders, respecting local cultures while maintaining global excellence.",
      image: images.newcase2
    },
    {
      title: "Diverse Collaboration",
      description: "We believe diverse perspectives fuel better solutions and stronger partnerships.",
      image: images.newpeople3
    },
    {
      title: "Trusted Resilience",
      description: "We build trust through consistent performance and resilience in the face of challenges.",
      image: images.newcase1
    }
  ];

  useEffect(() => {
    document.title = "About Us | Datamatics Consulting";
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="hero-static">
        <div className="hero-slide-wrapper">
          <img
            src={images.office1}
            alt="About Us"
            className="hero-background-image"
          />
          <div className="hero-overlay">
            <div className="hero-content">
              <h1 className="hero-title-about">ABOUT US</h1>
              <p className="hero-subtitle">Your Trusted Partner in Data and AI Excellence.</p>
            </div>
          </div>
        </div>
      </section>
      <Container className="page-container about-page">
        <Row>
          <Col md={10} lg={12} className="mx-auto">
            <div className="about-us-title-wrapper">
              <span className="purple-line-cs"></span>
              <h2>About Us</h2>
            </div>
            <p className="page-description">
              Datamatics Consulting was founded in Pakistan with a straightforward promise: deliver world-class Data and AI services that produce tangible, measurable results. That promise hasn't changed — only our impact has.
              A Global Perspective, A Pakistani Purpose
            </p>
          </Col>
        </Row>
      </Container>

      {/* Story of Our Evolution */}
      <div className="black-background-section">
        <Container>
          <Row>
            <Col md={10} lg={9} className="mx-auto">
              <h2 className="section-title section-title-large">Story of Our Evolution</h2>
              <p className="page-description">
                Our journey took us across the GCC, South Asia, Africa, Europe, and North America — building deep expertise through complex, high-stakes engagements with enterprises across emerging and mature markets alike. We didn't just observe global best practices. We helped shape them.
                But every milestone on that global path reinforced the same conviction — the most meaningful work we can do is here, at home. Pakistan is where we are most invested, most committed, and most driven to create lasting change.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="page-container about-page">
        <Row>
          <Col md={10} lg={12} className="mx-auto">
            {/* ====================== CORE VALUES ====================== */}
            <p className="section-title">The Foundation of Everything We Do</p>
            <p className="page-description">
              We don’t just build platforms; we build progress. Our approach combines technical precision with a deep understanding of the local landscape:
              Trusted Data Foundations: We build governed, secure data architectures that allow organizations to scale with absolute confidence.
              Scaling Machine Learning: We move beyond theory, deploying machine learning models that solve real-world problems and drive efficiency in our local markets.
              ISO-Aligned Operations: We bring the rigor of international operational standards to every project, ensuring reliability and long-term sustainability.
            </p>
            {/* Our Impact */}
            <h2 className="section-title mt-5">Our Impact</h2>
            <p className="page-description">
              Today, Datamatics Consulting stands as a premier global partner with a Pakistani heart. We are committed to proving that when Pakistani talent meets global experience, the results are world-class. Our goal is to deliver outcomes that go beyond the boardroom—empowering the communities, industries, and people of Pakistan to lead in the digital age.            </p>

            <h2 className="section-title">Our Core Values</h2>
            <div className="expertise-grid core-values-grid">
              {coreValues.map((value, index) => (
                <div key={index} className="expertise-card core-value-card">
                  <img
                    src={value.image}
                    alt={value.title}
                    className="card-image"
                  />
                  <div className="card-content">
                    <h3 className="card-title">{value.title}</h3>
                  </div>
                  <div className="card-hover-overlay top-hover">
                    <p className="card-description">{value.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Technology Progression */}
            <Row className="align-items-center g-4 mb-5 mt-3">
              <Col md={7}>
                <h2 className="section-title-small">Technology Progression</h2>
                <p className="page-description">
                  Technology is rapidly transforming the way businesses plan and operate.
                  Staying ahead requires adapting to constant change, and that’s where
                  Datamatics comes in. We bridge the gap between evolving technologies
                  and organizational data needs, empowering enterprises with advanced
                  analytics and AI. Backed by experienced consultants and cost-effective
                  delivery models, we ensure our clients remain competitive in an
                  ever-changing marketplace.
                </p>
              </Col>
              <Col md={5}>
                <div className="about-image-wrapper">
                  <img
                    src={images.purplap}
                    alt="Technology Progression"
                    className="about-image"
                    style={{ height: '320px', objectFit: 'cover' }}
                  />
                </div>
              </Col>
            </Row>

            {/* Our Vision */}
            <Row className="align-items-center g-4 mb-5">
              <Col md={5}>
                <div className="about-image-wrapper">
                  <img
                    src={images.laptop1}
                    alt="Our Vision"
                    className="about-image"
                    style={{ height: '340px', objectFit: 'cover' }}
                  />
                </div>
              </Col>
              <Col md={7}>
                <h3 className="section-title-small">Our Vision</h3>
                <p className="page-description">
                  Driving Global Impact through Data and AI excellence.<br /><br />
                  We aspire to drive transformation and measurable impact worldwide
                  through Data and AI excellence. By combining innovation, governance,
                  and scale, we help organizations shape a smarter and more connected future.
                </p>
              </Col>
            </Row>

            {/* Our Mission */}
            <Row className="align-items-center g-4 mb-5">
              <Col md={7}>
                <h3 className="section-title-small">Our Mission</h3>
                <p className="page-description">
                  Datamatics is on a mission to harness the power of Data & AI to
                  unite economies, elevate talent, and enable shared global growth.
                  In pursuing excellence, we create value that transcends borders and
                  transforms both enterprises and communities.
                </p>
              </Col>
              <Col md={5}>
                <div className="about-image-wrapper">
                  <img
                    src={images.laptop2}
                    alt="Our Mission"
                    className="about-image"
                    style={{ height: '340px', objectFit: 'cover' }}
                  />
                </div>
              </Col>
            </Row>

            {/* Our Clientele */}
            <Row className="align-items-center g-4 mb-5">
              <Col md={5}>
                <div className="about-image-wrapper">
                  <img
                    src={images.laptop3}
                    alt="Our Clientele"
                    className="about-image"
                    style={{ height: '320px', objectFit: 'cover' }}
                  />
                </div>
              </Col>
              <Col md={7}>
                <h2 className="section-title-small">Our Clientele</h2>
                <p className="page-description">
                  Our clientele is diverse, comprising of various organizations and
                  industries such as Telecommunications, Banking, Insurance, Manufacturing,
                  Retail and Government. Our services and delivery in the field of data
                  and analytics are as per client specific needs and requirements.
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default AboutUs;